import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Trans, useTranslation } from 'react-i18next';
import { useRedirectCompletionLink } from '@app/core';
import { LinkConfigurationCheckSection } from './LinkConfigurationCheckSection';
import { LinkConfigurationStepConfirmation } from '@app/api';
import { LinkConfigurationCheckElement } from './LinkConfigurationCheckElement';
import { LinkConfigurationMainBlock } from './LinkConfigurationMainBlock';
import { RedirectionLink } from './RedirectionLink';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    marginTop: theme.marginBase * 2,
  },
  text: {
    ...theme.fonts.caption,
  },
  redirectionLinks: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.marginBase * 3,
    // flexDirection: 'column',
  },
  link: {
    maxWidth: '50%',
  },
}));

interface Props {
  taskSettingId?: string;
  showUpsell?: boolean;
  openUpsellModal?: () => void;
}

const components = { b: <strong /> };

export const RecordingCompletion = ({
  taskSettingId,
  showUpsell,
  openUpsellModal,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const returnLinkConfiguration = useRedirectCompletionLink(taskSettingId);

  return (
    <LinkConfigurationCheckSection
      title={t(
        'editSession.linkConfiguration.studyLinkConfiguration.recordingCompletion.title',
      )}
      help={
        <Trans
          i18nKey="editSession.linkConfiguration.studyLinkConfiguration.recordingCompletion.help"
          components={components}
        />
      }
      className={classes.container}
    >
      <LinkConfigurationMainBlock
        text={
          <Trans
            i18nKey="editSession.linkConfiguration.studyLinkConfiguration.recordingCompletion.info"
            components={components}
          />
        }
        link={returnLinkConfiguration || ''}
        helpUrl={t(
          'editSession.linkConfiguration.studyLinkConfiguration.linkHelp',
        )}
        advancedUpsellModal={showUpsell ? openUpsellModal : undefined}
      >
        {showUpsell ? (
          <div />
        ) : (
          <>
            <p className={classes.text}>
              {t(
                'editSession.linkConfiguration.studyLinkConfiguration.recordingCompletion.advanced',
              )}
            </p>
            <div className={classes.redirectionLinks}>
              <RedirectionLink name="completed" taskSettingId={taskSettingId} />
              <RedirectionLink name="finished" taskSettingId={taskSettingId} />
              <RedirectionLink
                name="notSerious"
                taskSettingId={taskSettingId}
              />
              <RedirectionLink name="lied" taskSettingId={taskSettingId} />
              <RedirectionLink name="technical" taskSettingId={taskSettingId} />
              <RedirectionLink name="quotafull" taskSettingId={taskSettingId} />
              <RedirectionLink name="screenout" taskSettingId={taskSettingId} />
              <RedirectionLink name="legal" taskSettingId={taskSettingId} />
              <RedirectionLink name="duplicate" taskSettingId={taskSettingId} />
              <RedirectionLink name="quality" taskSettingId={taskSettingId} />
            </div>
          </>
        )}
      </LinkConfigurationMainBlock>

      <LinkConfigurationCheckElement
        linkConfigurationStep={
          LinkConfigurationStepConfirmation.RECORDING_COMPLETION_LINK
        }
      />
    </LinkConfigurationCheckSection>
  );
};
